import { forwardRef, useMemo } from 'react'
import { EChart, type EChartHandle } from './EChart'
import { buildFunnelOption, type FunnelInput, type FunnelStep } from './funnelOption'
import { useChartTheme } from './useChartTheme'

export interface FunnelStepsProps extends FunnelInput {
  height?: number
  loading?: boolean
  ariaLabel?: string
  className?: string
  texture?: boolean
  onStepClick?: (step: FunnelStep) => void
}

/** Воронка «показ → переход → корзина → заказ → выкуп» с конверсией между шагами и периодом сравнения. */
export const FunnelSteps = forwardRef<EChartHandle, FunnelStepsProps>(function FunnelSteps(
  { height, loading, ariaLabel, className, texture, onStepClick, ...input },
  ref,
) {
  const theme = useChartTheme()
  const option = useMemo(
    () => buildFunnelOption(input, theme),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [theme, input.steps, input.valueFormat, input.currentLabel, input.previousLabel],
  )
  const hasCompare = input.steps.some((step) => step.previous !== null && step.previous !== undefined)
  return (
    <EChart
      ref={ref}
      option={option}
      height={height ?? Math.max(160, input.steps.length * 44 + (hasCompare ? 40 : 8))}
      loading={loading}
      ariaLabel={ariaLabel}
      className={className}
      texture={texture}
      onMarkClick={(params) => {
        if (params.componentType !== 'series' || params.dataIndex === undefined) return
        const step = input.steps[params.dataIndex]
        if (step) onStepClick?.(step)
      }}
    />
  )
})

export default FunnelSteps
